export class CategoriaFinanceiraRequest {
    public descricao: string;
    public idTipoCategoriaFinanceira: number;
    public idCategoriaFinanceiraPai?: number;
    public idTipoCategoriaDre: number;
    public isAtivo: boolean = true;
    public idCategoriaMigracao?: number;
}
